<template>
    <div>
        <b-modal
            id="modify-status-popup"
            ref="modal"
            title=""
            size="sm"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            modal-class="hide-footer"
            :hide-header-close="loading"
            @hidden="onHidden"
        >
            <div slot="modal-header" class="w-100 archive-popup">
                <h5 class="modal-title">{{ modalTitle }}</h5>
            </div>
            <b-form
                class="modify-status-body"
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>{{ modalLabel }}</label>
                            <b-form-select
                                id="rating"
                                v-model="formData.status"
                                class="form-control"
                                :options="status"
                                autocomplete="no"
                            ></b-form-select>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        btn-label="update"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    props: {
        modalTitle: {
            type: String,
            required: true,
        },
    }, //
    watch: {
        hidePopup(val) {
            if (val) {
                this.onHidden()
            }
        },
        selectedItem(value) {
            if (value !== null && value !== undefined) {
                this.modalLabel = value.value
                Object.assign(this.formData, value)
            } else {
                this.onHidden()
            }
        },
    },
    computed: {
        ...mapGetters(['loading', 'hidePopup', 'selectedItem']),
    },
    data() {
        return {
            formData: this.initializeFormData(),
            status: [
                { text: 'Active', value: 'active' },
                { text: 'Inactive', value: 'archived' },
            ],
            modalLabel: 'Field',
        }
    },
    methods: {
        initializeFormData() {
            return {
                _id: null,
                status: 'active',
                dataSegmentId: null,
            }
        }, // End of initializeFormData() method
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */
        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    this.formData.type = 'status'
                    await this.$store.dispatch('onSubmit', this.formData)
                } catch (error) {
                    //console.log(error, 'There is an error on submit')
                }
            }
        }, // End of onSubmit() method
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
    },
}
</script>
